import { render, staticRenderFns } from "./CopyrightAmendmentTask.vue?vue&type=template&id=e97ad0a6&scoped=true&"
import script from "./CopyrightAmendmentTask.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentTask.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentTask.vue?vue&type=style&index=0&id=e97ad0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ad0a6",
  null
  
)

export default component.exports